import { EMoneySource } from '../user';
import { IPublishTermsService } from './publishTermsService';
import { IPublishTermsMessage } from './publishTermsMessage';
import { EPlacingType } from './placingType';
import { IServicePackage, IServicePackages } from './packages';
import { IPeriodsByService } from './periods';
import { EServiceId } from './serviceId';
import { IPublication } from './publication';

export enum EPublishTermsAvailableMoneySources {
  MasterAndSelf = 'masterAndSelf',
  Master = 'master',
  Self = 'self',
}

export interface IPublishTerms {
  /** Подключена ли автопролонгация к объявлению **/
  autoProlong: boolean;
  /** Услуги размещения */
  services: IPublishTermsServices;
  /** Отсортированный список услуг размещения */
  serviceIds: EServiceId[];
  /** Выбранная услуга размещения */
  selectedServiceId: EServiceId | null;
  /** Услуга продвижения в карточке "Ваша ставка". Меняется в зависимости от введенной ставки */
  promotionServiceId: EServiceId | null;
  /** Сообщение об ограничении услуг */
  message: IPublishTermsMessage | null;
  /** Публикация на других площадках **/
  isMultipostingAvailable: boolean;
  /** Группа эксперимента мультипостинга **/
  multipostingABGroup: string | null;
  /** Пакеты размещения */
  packages: IServicePackages;
  /** Периоды размещения */
  periodsByService: IPeriodsByService;
  /** Отсортированный список пакетов размещения */
  packageIds: IServicePackage['id'][];
  /** Выбранный пакет размещения */
  selectedPackageId: string | null;
  /** Выбранный период размещения */
  selectedPeriodId: number | null;
  /** Выбранный тип размещения */
  selectedPlacingType: EPlacingType | null;
  /** Данные публикации */
  publication: IPublication;
  /** Счёт размещения **/
  moneySource: EMoneySource | null;
  /** Флаг активности продвижения в поиске */
  isServicesEnabled: boolean;
  /** Доступные счета для размещения */
  availableMoneySources: EPublishTermsAvailableMoneySources;
  /** Коэффициент, на к-ый умножены цены (если применён эксперимент дифференцирования цены) **/
  highDemandCoefficient: number | null;
  /** Причина переключения услуги из апи check-service */
  promotionTypeChangeReason: null | string;
}

export type IPublishTermsServices = {
  [serviceId in EServiceId]: IPublishTermsService;
};
